import React, { useState } from 'react';
import { getVersionInfo } from '../version.js';

const VersionInfo = ({ className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [apiVersion, setApiVersion] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const versionInfo = getVersionInfo();
  
  const fetchApiVersion = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${versionInfo.api_url}/version`);
      if (response.ok) {
        const data = await response.json();
        setApiVersion(data);
      } else {
        setApiVersion({ error: 'Failed to fetch API version' });
      }
    } catch (error) {
      setApiVersion({ error: error.message });
    }
    setLoading(false);
  };
  
  React.useEffect(() => {
    if (isVisible && !apiVersion) {
      fetchApiVersion();
    }
  }, [isVisible]);
  
  if (!isVisible) {
    return (
      <div className={`fixed bottom-4 right-4 ${className}`}>
        <button
          onClick={() => setIsVisible(true)}
          className="bg-blue-600 text-white px-3 py-1 rounded text-xs hover:bg-blue-700 transition-colors"
          title="Show version information"
        >
          v{versionInfo.version}
        </button>
      </div>
    );
  }
  
  return (
    <div className={`fixed bottom-4 right-4 bg-white border border-gray-300 rounded-lg shadow-lg p-4 max-w-md ${className}`}>
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-semibold text-gray-900">Version Information</h3>
        <button
          onClick={() => setIsVisible(false)}
          className="text-gray-400 hover:text-gray-600"
          title="Close"
        >
          ×
        </button>
      </div>
      
      <div className="space-y-2 text-sm">
        <div className="border-b pb-2">
          <h4 className="font-medium text-blue-600">Frontend (Client)</h4>
          <div className="text-gray-600 space-y-1">
            <div>Version: <span className="font-mono">{versionInfo.version}</span></div>
            <div>Build: <span className="font-mono">{versionInfo.commit_hash}</span></div>
            <div>Time: <span className="font-mono">{versionInfo.build_time}</span></div>
            <div>Environment: <span className="font-mono">{versionInfo.environment}</span></div>
          </div>
        </div>
        
        <div className="pt-2">
          <h4 className="font-medium text-green-600">Backend (API)</h4>
          {loading ? (
            <div className="text-gray-500">Loading...</div>
          ) : apiVersion?.error ? (
            <div className="text-red-500">{apiVersion.error}</div>
          ) : apiVersion ? (
            <div className="text-gray-600 space-y-1">
              <div>Version: <span className="font-mono">{apiVersion.version}</span></div>
              <div>Build: <span className="font-mono">{apiVersion.commit_hash}</span></div>
              <div>Time: <span className="font-mono">{apiVersion.build_time}</span></div>
              <div>Environment: <span className="font-mono">{apiVersion.environment}</span></div>
            </div>
          ) : (
            <button
              onClick={fetchApiVersion}
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Load API version
            </button>
          )}
        </div>
      </div>
      
      <div className="mt-3 pt-2 border-t text-xs text-gray-500">
        API URL: <span className="font-mono">{versionInfo.api_url}</span>
      </div>
    </div>
  );
};

export default VersionInfo;